var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChecklist = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.083 3.333H5c-.92 0-1.667.747-1.667 1.667v11.667c0 .92.746 1.666 1.667 1.666h5M12.917 3.333H15c.92 0 1.667.747 1.667 1.667v7.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.667 5.333V3.75c0-.23.187-.417.417-.417.23 0 .42-.186.46-.413C7.666 2.21 8.144.833 10 .833s2.334 1.377 2.457 2.087c.04.227.23.413.46.413s.417.187.417.417v1.583a.5.5 0 0 1-.5.5H7.167a.5.5 0 0 1-.5-.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.917 17.083 1.667 1.667 4.166-4.167",
  strokeLinejoin: "round"
}))));
export default SvgChecklist;